import React from "react";

const Logo = () => {
  return (
    <div className="st">
      <div className="st-top">
        <div className="st-bound st-bound-full"></div>
        <p id="topLogoFr">
          <span className="st-drop st-stranger-s">S</span>
          <span className="st-stranger-t">t</span>
          <span className="st-stranger-r">r</span>
          <span className="st-stranger-a">a</span>
          <span className="st-stranger-n">n</span>
          <span className="st-stranger-g">g</span>
          <span className="st-stranger-e">e</span>
          <span className="st-stranger-r-2">r'</span>
          <span className="st-stranger-space"> </span>
          <span className="st-drop st-stranger-s-2">s</span>
        </p>
        <div className="st-bound st-bound-mini st-bound-left"></div>
        <div className="st-bound st-bound-mini st-bound-right"></div>
      </div>

      <div className="st-bottom">
        <p id="bottomLogoFr">
          <span className="st-things-t">T</span>
          <span className="st-things-h">h</span>
          <span className="st-things-i">i</span>
          <span className="st-things-n">n</span>
          <span className="st-things-g">g</span>
          <span className="st-things-s">s</span>
        </p>
      </div>
    </div>
  );
};
export default Logo;
